import { createAsyncThunk } from '@reduxjs/toolkit';

import type { CitacaoRegistrada, RegistrarCitacaoArgs } from '../../types/registroCitacao';
import { mensagemDoRegistroCitacao } from '../../utils/registroCitacao';
import { fetchPartesProcesso } from '../actions';
import { registroCitacaoService } from './services';

/**
 * Recarrega as partes depois do registro: é de lá que sai o `citado` que esconde a ação, e a
 * ficha que ficasse com o dado velho ofereceria registrar de novo a mesma citação (409).
 */
export const registrarCitacaoParte = createAsyncThunk<
  CitacaoRegistrada,
  RegistrarCitacaoArgs,
  { rejectValue: string }
>('secretariaArbitralRegistroCitacao/registrar', async (args, { dispatch, rejectWithValue }) => {
  try {
    const registrada = await registroCitacaoService.registrar(args);
    await dispatch(fetchPartesProcesso(args.processoId));
    return registrada;
  } catch (error: unknown) {
    return rejectWithValue(mensagemDoRegistroCitacao(error));
  }
});
